import type { MedicationOption, ProductDetailPage } from '@/types/interfaces/productDetailPage'

type PageContent = ProductDetailPage['page_content']

/**
 * CMS content for the dose form the customer is looking at.
 * An option that includes `page_content` uses that value, including null when
 * nothing is configured for its SKU. An option that omits the field uses the
 * page-level content from the SKU the page was requested with.
 */
export function pageContentForMedicationOption(
    page: Pick<ProductDetailPage, 'page_content'>,
    option: Pick<MedicationOption, 'page_content'>,
): PageContent {
    if (option.page_content !== undefined) return option.page_content
    return page.page_content
}
